
import Vue from 'vue'
import '@/components/GmapGroundOverlay'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class GroundOverlayViewer extends Vue {
  @Prop({ type: Array }) overlays!: string[]
}
